import { headerBgGradient1 } from "./HeaderBgStore";

export const updateHeaderBgGradient1 = (value) => headerBgGradient1.update(oldValue => value);
